import { useEffect, useState } from 'react';
import type { NotApplicableCampaignStorage } from 'src/common/interfaces/campaigns';
import { readStoredNotApplicableCampaign } from '../helpers/campaign-storage';

export const useNotApplicableCampaign = () => {
  const [notApplicableCampaign, setNotApplicableCampaign] = useState<NotApplicableCampaignStorage | undefined>();

  useEffect(() => {
    const notApplicableCampaign = readStoredNotApplicableCampaign();
    setNotApplicableCampaign(notApplicableCampaign);
  }, []);

  return { notApplicableCampaign };
};
